import { initConditionalUpdaterHelper } from "./admin/conditional-updater-helper";
import { initMdContentEditor } from "./admin/mdContent-editor";
import { initAds } from "./ads";
import { initEqSet } from "./eq-set";
import { initExtendedItemInfo } from "./extended-item-info/extended-info-loader";
import { initItemLoader } from "./item-loader";
import { initSkillSimulator } from "./skill-simulator";
import { initTipApiFix } from "./tip-api-fix";
import { initTip } from "./tips";
import { initWorld } from "./world";

import "./scss/main.scss";

// Needed by garmory tip api
// @ts-ignore
window.items = {};

initTip();
initTipApiFix();
initItemLoader();
initExtendedItemInfo();
initEqSet();
initSkillSimulator();
initAds();

if (location.pathname.startsWith("/world-frame")) {
    initWorld();
}

if (location.pathname.startsWith("/admin/conditional-updater/selector")) {
    initConditionalUpdaterHelper();
}

if (location.pathname.startsWith("/admin/mdContent/edit")) {
    initMdContentEditor();
}
